export const SPELL_DAYS = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];

export function getSpelling(childId) {
  try { const v = localStorage.getItem(`rq:spelling:${childId}`); return v ? JSON.parse(v) : null; } catch { return null; }
}

export function saveSpellingData(childId, data) {
  try { localStorage.setItem(`rq:spelling:${childId}`, JSON.stringify(data)); } catch {}
}

export function getSpellingArchive(childId) {
  try { const v = localStorage.getItem(`rq:spelling-archive:${childId}`); return v ? JSON.parse(v) : []; } catch { return []; }
}

export function archiveSpellingWeek(childId) {
  const data = getSpelling(childId); if (!data) return;
  const archive = getSpellingArchive(childId);
  try { localStorage.setItem(`rq:spelling-archive:${childId}`, JSON.stringify([...archive, {week: data.createdAt, words: data.words || [], testDay: data.testDay || 'friday'}].slice(-4))); } catch {}
  try { localStorage.removeItem(`rq:spelling:${childId}`); } catch {}
}

export function checkAndArchiveSpelling(childId) {
  const data = getSpelling(childId);
  if (!data || !data.active || !data.createdAt) return false;
  const testDayIdx = SPELL_DAYS.indexOf((data.testDay || 'friday').toLowerCase());
  if (testDayIdx < 0) return false;
  const created = new Date(data.createdAt);
  const daysUntilRaw = ((testDayIdx - created.getDay()) + 7) % 7;
  const daysUntil = daysUntilRaw === 0 ? 7 : daysUntilRaw;
  const testDate = new Date(created);
  testDate.setDate(created.getDate() + daysUntil);
  testDate.setHours(23, 59, 59, 999);
  if (new Date() > testDate) { archiveSpellingWeek(childId); return true; }
  return false;
}

export function getSpellingWords(childId) {
  const data = getSpelling(childId);
  if (!data || !data.active || !data.words) return [];
  return data.words;
}

export function getSpellingMastery(childId, wordMastery) {
  const words = getSpellingWords(childId);
  if (!words.length) return { mastered: 0, total: 0, words: [] };
  const enriched = words.map(w => ({...w, masteredInApp: (wordMastery?.[w.word]?.correct || 0) >= 3}));
  return { mastered: enriched.filter(w => w.masteredInApp).length, total: words.length, words: enriched };
}
